import {EncounterTypeEnum} from './encounter_constants';
import {
  ICON_ENCOUNTER,
  ICON_OUTPATIENT,
  ROUTE_ENCOUNTER,
  ROUTE_OUTPATIENT,
} from 'src/js/containers/dashboard/dashboard_constants';

export const getRouteAndIconName = (encounterType: EncounterTypeEnum) => {
  let route = '';
  let iconName = '';

  switch (encounterType) {
    case EncounterTypeEnum.Hospitalization:
      iconName = ICON_ENCOUNTER;
      route = ROUTE_ENCOUNTER;
      break;
    case EncounterTypeEnum.Outpatient:
      iconName = ICON_OUTPATIENT;
      route = ROUTE_OUTPATIENT;
      break;
    default:
      console.warn(`Error: Unknown encounterType: ${encounterType}`);
  }

  return {route, iconName};
};
